// extracted by mini-css-extract-plugin
export default {"intro":"About_intro__qtHDI","aboutimg":"About_aboutimg__rUYNJ"};